import React from 'react'

const GreenTickIcon = () => {
    return (
        <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" width="40" height="40" rx="20" fill="#D9F0E2" />
            <g clipPath="url(#clip0_3788_22141)">
                <path d="M20.5007 34.8686C28.7142 34.8686 35.3725 28.2103 35.3725 19.9968C35.3725 11.7833 28.7142 5.125 20.5007 5.125C12.2872 5.125 5.62891 11.7833 5.62891 19.9968C5.62891 28.2103 12.2872 34.8686 20.5007 34.8686Z" fill="#6BB577" />
                <path d="M17.4233 28.2049C17.0166 28.2049 16.6248 28.0438 16.3356 27.7541L12.233 23.6515C11.632 23.051 11.632 22.0766 12.233 21.4761C12.8335 20.8751 13.8079 20.8751 14.4084 21.4761L17.2566 24.3243L25.4227 13.4356C25.9335 12.7556 26.8986 12.6187 27.5766 13.1279C28.2566 13.6377 28.3945 14.6023 27.8848 15.2818L18.654 27.5895C18.3868 27.9464 17.9771 28.1695 17.5325 28.2007C17.4961 28.2033 17.4591 28.2049 17.4233 28.2049Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_3788_22141">
                    <rect width="30.7692" height="30.7692" fill="white" transform="translate(5.11523 4.61719)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default GreenTickIcon
